export default __webpack_public_path__ + "static/media/jj1_bg.216aa8d6.png";